import { ControlUnitAPIResponse } from '../../../controlUnit/api/ControlUnit.model';
import {
  CommanderTranslationAPIResponse,
  ControlUnitTranslationAPIResponse,
  TranslationCommanderObject,
  TranslationControlUnitObject,
} from '../CUTranslation.model';
import { CUTranslationState } from '../../slice/CUTranslationSlice';

/** function to get translation from dictionaries inspired by ST-Studio does */
export const getTranslateFunction =
  (
    translations: ControlUnitTranslationAPIResponse | undefined,
    commanderTranslations: CommanderTranslationAPIResponse | undefined,
    controlUnitIdParam: string | number = ''
  ) =>
  (
    keyTranslation: string,
    controlUnitId: string | number | undefined = controlUnitIdParam,
    // Always would search in CommanderTranslations first, then in the type translation
    type: 'ram' | 'parameters' = 'ram',
    keyTranslationObject:
      | keyof TranslationCommanderObject
      | keyof TranslationControlUnitObject = 'shortText',
    // return keyTranslation if not found
    fallback = true,
    /** try to found the translations in another parts of the translations,
     * some times has any equivalent with another key, take a look a commanderValues*/
    recursion = false
  ): string | { id: string; text: string }[] => {
    const textCommanderTranslations =
      commanderTranslations?.[keyTranslation]?.[
        keyTranslationObject as keyof TranslationCommanderObject
      ];
    if (textCommanderTranslations) return textCommanderTranslations;

    // get from RAM or PARAMS
    const ramTranslations = translations?.translations?.ramValues ?? {};
    const paramTranslations =
      translations?.translations?.parameterTranslations ?? {};

    let text: string | { id: string; text: string }[] | null | undefined = '';
    switch (type) {
      case 'parameters':
        text =
          paramTranslations[keyTranslation]?.[
            keyTranslationObject as keyof TranslationControlUnitObject
          ];
        break;

      case 'ram':
        text =
          ramTranslations[keyTranslation]?.[
            keyTranslationObject as keyof TranslationControlUnitObject
          ];
        break;

      default:
        break;
    }
    if (text?.length) return text;

    // Try to find the value with the equality, because some times F01 has a real name like H11
    const valuesTranslations =
      translations?.translations?.commanderValues ?? ({} as any);
    const equalityText = valuesTranslations[keyTranslation];
    if (equalityText && !recursion)
      return getTranslateFunction(
        translations,
        commanderTranslations,
        controlUnitId
      )(
        keyTranslation,
        controlUnitId,
        type,
        keyTranslationObject,
        fallback,
        true
      );
    return '';
  };

export const getTranslateManyDevicesFunction =
  (translationsState: CUTranslationState['dictionaryCUTranslation'] = {}) =>
  (
    keyTranslation: string,
    deviceId: string | undefined = '',
    controlUnitId: string | number = '',
    // Always would search in CommanderTranslations first, then in the type translation
    type: 'ram' | 'parameters' = 'ram',
    keyTranslationObject:
      | keyof TranslationCommanderObject
      | keyof TranslationControlUnitObject = 'shortText',
    // return keyTranslation if not found
    fallback = true,
    recursion = false
  ): string | { id: string; text: string }[] => {
    const translations = translationsState[deviceId] ?? {};
    // get from commanderTranslations
    const commanderTranslations =
      // @ts-ignore
      translations[controlUnitId]?.translations?.commanderTranslation ??
      // @ts-ignore
      Object.values(translations)[0]?.translations?.commanderTranslation ??
      [];
    // @ts-ignore
    const textCommanderTranslations = commanderTranslations.find(
      // @ts-ignore
      (commanderTranslation) => commanderTranslation.key === keyTranslation
    )?.[keyTranslationObject as keyof TranslationCommanderObject];
    if (textCommanderTranslations) return textCommanderTranslations;

    // get from RAM or PARAMS
    const ramTranslations =
      translations[controlUnitId]?.translations?.ramValues ?? {};
    const paramTranslations =
      translations[controlUnitId]?.translations?.parameterTranslations ?? {};

    let text: string | { id: string; text: string }[] | null | undefined;
    switch (type) {
      case 'parameters':
        text =
          paramTranslations[keyTranslation]?.[
            keyTranslationObject as keyof TranslationControlUnitObject
          ];
        break;

      case 'ram':
        text =
          ramTranslations[keyTranslation]?.[
            keyTranslationObject as keyof TranslationControlUnitObject
          ];
        break;

      default:
        break;
    }
    if (text?.length) return text;

    // Try to find the value with the equality, because some times F01 has a real name like H11
    const valuesTranslations =
      translations[controlUnitId]?.translations?.commanderValues ?? ({} as any);
    const equalityText = valuesTranslations[keyTranslation];
    if (equalityText && !recursion)
      // @ts-ignore
      return getTranslateFunction(translations, {})(
        keyTranslation,
        controlUnitId,
        type,
        keyTranslationObject,
        fallback,
        true
      );
    return fallback ? keyTranslation : '';
  };
